<template>
    <DataComponent
        class="w-full mt-6"
        :data="data"
        :initialSort="initialSort"
        :disableSort="disableSort"
        @sort="onSort">
        
        <DataField name="student" class="whitespace-no-wrap md:text-sm">
            <template v-slot="{row}">
                <router-link
                    :to="{ name: assignmentEditRoute, params: {courseId: row.course_id, assignmentId: row.id}}"
                    class="text-indigo-600 hover:text-indigo-900">
                    {{ row.student.firstname + ' ' + row.student.lastname }}
                </router-link>
            </template>
        </DataField>
        <DataField name="title" class="whitespace-no-wrap md:text-sm">
            <template v-slot="{row}">
                <router-link
                    :to="{ name: assignmentEditRoute, params: {courseId: row.course_id, assignmentId: row.id}}"
                    class="text-indigo-600 hover:text-indigo-900">
                    {{ row.title }}
                </router-link>
            </template>
        </DataField>
        <DataField name="actions" :sortable="false" :showLabel="false" :showResponsiveLabel="false">
            <template v-slot="{row}">
                <div class="flex justify-around md:justify-end items-center">
                    <router-link
                        v-if="row.user_can.update"
                        class="text-indigo-600 hover:text-indigo-900 mr-4"
                        :to="{name: assignmentEditRoute, params: {courseId: row.course_id, assignmentId: row.id}}">
                        Edit
                    </router-link>
                </div>
            </template>
        </DataField>
    </DataComponent>
</template>

<script>

import {DataComponent, DataField} from "@/Components/DataComponent";
import CalendarFormat from "@/Components/CalendarFormat";
import dayjs from "dayjs";
import {sortBy} from "lodash";
import axios from "axios";

export default {

    name: "AssignmentDataComponent",

    props: {
        ...DataComponent.props,
        isCertificate: {
            type: Boolean,
            default: () => false
        },
    },

    data() {
        return {}
    },

    components: {
        DataComponent,
        DataField,
        CalendarFormat,
    },

    methods: {
        onSort(data) {
            this.$emit('sort', data);
        },
    },

    computed: {
        assignmentEditRoute() {
            return !this.isCertificate ? 'admin.assignments.edit' : 'admin.certificates.edit';
        }
    }
};

</script>
